// extracted by mini-css-extract-plugin
module.exports = {"card":"style_card__2P82i","detail":"style_detail__3Fj5M"};